import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import FormikAutosuggest from 'components/formik/Autosuggest';
import TextField from 'components/formik/TextField';
import { Field, FieldArray, useFormikContext } from 'formik';
import DeleteIcon from 'mdi-react/DeleteIcon';
import { string } from 'prop-types';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';

const getStyles = theme => ({
  table: {
    marginTop: theme.spacing(3),
  },
  tableField: {
    padding: theme.spacing(1),
    paddingLeft: 0,
  },
  addButton: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
});

const ChatFlowParametersTable = ({ name }) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const { getFieldProps } = useFormikContext();
  const { value } = getFieldProps(name);
  return (
    <FieldArray
      name={name}
      render={arrayHelpers => (
        <div>
          {value?.length > 0 && (
            <Table size="small" padding="none" sx={styles.table}>
              <TableHead>
                <TableRow hover={false}>
                  <TableCell style={{ width: '30%' }}>
                    {I18n.t('ChatFlowSettings.Parameter')}
                  </TableCell>
                  <TableCell style={{ width: '20%' }}>{I18n.t('ChatFlowSettings.Type')}</TableCell>
                  <TableCell style={{ width: '50%' }}>{I18n.t('ChatFlowSettings.Value')}</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {value.map((p, idx) => (
                  <TableRow key={p._id} hover={false}>
                    <TableCell>
                      <Field
                        component={TextField}
                        name={`${name}.${idx}.id`}
                        placeholder={I18n.t('ChatFlowSettings.parameters.id')}
                        sx={styles.tableField}
                      />
                    </TableCell>
                    <TableCell>
                      <Box sx={styles.tableField}>
                        <Field
                          component={FormikAutosuggest}
                          components={{
                            IndicatorsContainer: () => null,
                          }}
                          suggestions={['any', 'date', 'number', 'integer'].map(typeValue => ({
                            value: typeValue,
                            label: typeValue,
                          }))}
                          placeholder={I18n.t('ChatFlowSettings.parameters.type')}
                          name={`${name}.${idx}.type`}
                          styles={{
                            valueContainer: provided => ({
                              ...provided,
                              paddingLeft: 0,
                            }),
                          }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Field
                        component={TextField}
                        name={`${name}.${idx}.value`}
                        placeholder={I18n.t('ChatFlowSettings.parameters.value')}
                        sx={styles.tableField}
                      />
                    </TableCell>
                    <TableCell>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => arrayHelpers.remove(idx)}
                        size="large"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
          <Button
            variant="text"
            color="primary"
            sx={styles.addButton}
            onClick={() => arrayHelpers.push({})}
          >
            {I18n.t('ChatFlowSettings.Add parameter')}
          </Button>
        </div>
      )}
    />
  );
};

ChatFlowParametersTable.propTypes = {
  name: string.isRequired,
};

export default ChatFlowParametersTable;
